<template>
  <div class="d-activity-removal modal active">
    <div class="overlay" />

    <div class="modal-content">
      <div class="modal-header">
        <h4>Delete post?</h4>
        <a
          class="button button-yellow button-icon button-close-white button-close-modal"
          @click="dismiss"
        />
      </div>

      <div
        class="modal-body loadable"
        :class="{ 'loading': isProcessing }"
      >
        <div
          v-if="isProcessing"
          class="loading-content"
        >
          <DuiLoadingIndicator size="lg" />
          <p class="space-top-2em">
            Removing post...
          </p>
        </div>

        <div class="loaded-content">
          <p class="space-bottom-2em">
            Please confirm that you would like to remove
            this post. Once removed, you won't be able
            to get it back!
          </p>

          <div class="button-pair right space-top-3em">
            <button
              :disabled="isProcessing"
              type="button"
              @click="dismiss"
            >
              Cancel
            </button>
            <button
              class="button-yellow"
              :disabled="isProcessing"
              type="button"
              @click="deleteActivity"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import activityFeedService from '@d-services/activity-feed-service/activity-feed-service';
import { getErrorMessage } from '@d-shared/utils/errors';
import modalMixin from '@d-mixins/modal';

export default {
  mixins: [
    modalMixin,
  ],
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isProcessing: false,
  }),
  methods: {
    async deleteActivity() {
      this.$set(this, 'isProcessing', true);

      try {
        await activityFeedService.deletePost(this.activity.slug);
        Vue.duiNotificationManager.success('Post removed.');
        this.$emit('activity-removed');
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },

    dismiss() {
      this.$emit('dismiss');
    },
  },
};
</script>
